// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown .el-dropdown-menu__item:hover{background:#f4f6f8!important;color:#c31422!important}.dropdown .active{color:#c31422!important}", ""]);
// Exports
module.exports = exports;
